import { HttpClient } from '@angular/common/http';
import { environment } from '../../config/environments/environment';
import { Injectable } from '@angular/core';
import { Event } from '../models/interfaces/event';
import { Observable } from 'rxjs';
import { ReceivedResourcesDto } from '../models/dto/count-users.dto';
import { PageDto } from '../models/dto/arrival/page.dto';
import { OccasionParamsDto } from '../models/dto/occasion-params.dto';

@Injectable()
export class EventsService {
  private readonly eventsPath = 'events';
  private readonly summaryPath = 'summary';

  constructor(private http: HttpClient) {}

  public getAll(params?: OccasionParamsDto): Observable<PageDto<Event>> {
    const url = `${environment.api.baseUrl}/${this.eventsPath}/v2`;
    return this.http.get<PageDto<Event>>(url, {
      params: this.buildHttpParams(params),
    });
  }

  public countUsersReceived(id: string): Promise<ReceivedResourcesDto> {
    return this.http
      .get<ReceivedResourcesDto>(
        `${environment.api.baseUrl}/${this.eventsPath}/${id}/${this.summaryPath}`
      )
      .toPromise();
  }

  public getById(id: string): Observable<Event> {
    return this.http.get<Event>(
      `${environment.api.baseUrl}/${this.eventsPath}/${id}`
    );
  }

  public getByUserId(userId: string): Observable<Event[]> {
    return this.http.get<Event[]>(
      `${environment.api.baseUrl}/${this.eventsPath}/${userId}`
    );
  }

  public save(event: Event): Observable<string> {
    return this.http.post(
      `${environment.api.baseUrl}/${this.eventsPath}`,
      event,
      { responseType: 'text' }
    );
  }

  public update(event: Event): Observable<string> {
    return this.http.put(
      `${environment.api.baseUrl}/${this.eventsPath}/v2/${event.id}`,
      event,
      { responseType: 'text' }
    );
  }

  public remove(eventId: string): Observable<string> {
    return this.http.delete(
      `${environment.api.baseUrl}/${this.eventsPath}/${eventId}`,
      { responseType: 'text' }
    );
  }

  private buildHttpParams(params?: OccasionParamsDto): any {
    const httpParams: any = {};

    if (params?.year) {
      httpParams.year = params.year;
    }

    if (params?.month || params?.month === 0) {
      httpParams.month = params.month;
    }

    if (params?.released) {
      httpParams.released = params.released;
    }

    if (params?.scheduled) {
      httpParams.scheduled = params.scheduled;
    }

    if (params?.limit) {
      httpParams.limit = params.limit;
    }

    if (params?.page) {
      httpParams.page = params.page;
    }

    if (params?.idSchool) {
      httpParams.idSchool = params.idSchool;
    }

    if (params?.idsClassrooms && params?.idsClassrooms.length > 0) {
      httpParams.idsClassrooms = params.idsClassrooms.join(',');
    }

    if (params?.textSearch) {
      httpParams.textSearch = params.textSearch;
    }
    
    return httpParams;
  }
}
